module.exports = __webpack_public_path__ + "static/media/stellarcircus.5dc07768.png";